import { useAsyncExecutor } from "async-executor-hook";
import { useEffect, useState } from "react";
import { getErrorValueResponse } from "../../common/error/Error";

import { HTTP_METHODS } from "../../utils/constants";
import { networkBackendRequest } from "../../utils/networkUtils";
import { formatFilters } from "./CreditAuthFilters";

function useFetchAffectedVolantes(filters, onErrorMessage, onRemoveInvoice) {
  const [invoicesRows, updateInvoicesRows] = useState([]);

  const dataInvoices: any = useAsyncExecutor(
    async ({ page, filters }) => {
      const params = formatFilters(filters);
      const paramsSearch = {
        ...params,
        order: "descending",
        payer_ruc_option: ["consignee", "cargo_agent", "third_party_agency"],
        page: page ?? 1,
      };
      return await networkBackendRequest(
        "/invoices/payment-status/",
        HTTP_METHODS.GET,
        paramsSearch
      ).then((resp) => resp.json());
    },
    {
      onSuccess: (data) => {
        updateInvoicesRows(data.invoices);
      },
      onError: (error) => {
        const errorMessage = getErrorValueResponse(error);
        onErrorMessage(errorMessage);
      },
    }
  );

  const removeInvoice = useAsyncExecutor(
    async (params: any) => {
      const data = {
        payment_status_option: "quoted",
        payer_ruc_option:
          params.selectedRows.credit_payment_detail.payer_ruc.option,
      };
      return await networkBackendRequest(
        `/invoices/rollback/${params.selectedRows.invoice_id}/`,
        HTTP_METHODS.PATCH,
        {},
        data
      ).then((resp) => resp.json());
    },
    {
      onSuccess: () => {
        onRemoveInvoice();
        dataInvoices.retry();
      },
      onError: (error) => {
        const errorMessage = getErrorValueResponse(error);
        onErrorMessage(errorMessage);
      },
    }
  );

  useEffect(() => {
    dataInvoices.execute({ filters });
    // eslint-disable-next-line
  }, []);

  return [invoicesRows, dataInvoices, removeInvoice];
}

export default useFetchAffectedVolantes;
